import { useState } from "react";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import {
  addtowishlist,
} from "../../../../../redux/posts/action";
import Pagination from "./CustomPagination/Pagination";
import PostNotFound from "../../../../CustomComponents/AllLoader/PostNotFound";
import getTimeDifference from "../../../../Common/TimeDifference";
import { getMemberSince } from "../../../../Common/AllDateTimeReleventFormate";
import CustomeDurationLabel from "../../../../Common/CustomeLabel/CustomeDurationLabel";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import GetPrice from "../../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetPrice";
import YourPost from "../../../../Common/Label/YourPost";
import PostReportMenu from "../../../../Common/Label/PostReportMenu";
import { navigateToNextTab } from "../../../../Common/FewCommonMethods";
import { getPostType, getSortNamePostType, IS_LOGGED_IN_USER, decodeHtml, getUmbrella } from "../../../../../assests/extention/commonfunction";
import Access from "../../../../CustomComponents/Access/Access";
import CommonPagination from "../../../../Common/PaginationComponet/CommonPagination";
import { useAllFilterBaseContext } from "../../../../../Context/AllFilterBaseContext";
import { useStateContext } from "../../../../../Context/StateContext";
import AllStatusLabels from "./AllStatusLabels";

export default function RecentPosts({ data, activeTab }) {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const getpostlist = useSelector(
    ({ posts: { getfilterdpost } }) => getfilterdpost
  );
  const { state, setPageNumber } = useStateContext();

  const navigatetopost = (item) => {
    switch (item.type) {
      case "1":
        navigateToNextTab(`projectdetails/${item.id}`);
        // navigate(`/${lan}/projectdetails/${item.id}`);
        break;
      case "2":
        navigateToNextTab(`contestdetails/${item.id}`);
        // navigate(`/${lan}/contestdetails/${item.id}`);
        break;
      case "3":
        navigateToNextTab(`jobdetails/${item.id}`);
        // navigate(`/${lan}/jobdetails/${item.id}`);
        break;
      case "4":
        navigateToNextTab(`umbrelladetails/${item.id}`);
        // navigate(`/${lan}/umbrelladetails/${item.id}`);
        break;
      default:
        navigateToNextTab(`projectdetails/${item.id}`);
        // navigate(`/${lan}/projectdetails/${item.id}`);
        break;
    }
  };

  const addtowishlist11 = (id) => {
    dispatch(addtowishlist(id, data));
  };

  // item.type here is this feed's own internal categorization (1=project,2=contest,3=job,4=umbrella),
  // which is different from the report API's master_type scheme. Map to master_type; umbrella has no
  // reportable master_type of its own, so it resolves to null and the report menu stays hidden.
  const getMasterTypeForRecentPost = (type) => {
    switch (String(type)) {
      case "1":
        return 5; // Post & Browse Projects (PBP)
      case "2":
        return 7; // Win business Opportunities (WBO)
      case "3":
        return 9; // Part time Job (PTJ)
      default:
        return null;
    }
  };

  return (
    <div>
      {modal ? (<Access modal={modal} setModal={setModal} state={"state"} />) : ("")}
      {Array.isArray(getpostlist?.response) &&
        getpostlist?.response.length > 0 ? (
        <>
          {getpostlist?.response?.map(
            (item, index) =>
              index < 100 && (
                <div className="filter-detail" style={{ position: "relative" }} key={index}>
                  <PostReportMenu
                    item={item}
                    masterType={getMasterTypeForRecentPost(item?.type)}
                  />
                  <div
                    onClick={() => {
                      navigatetopost(item);
                    }}
                  >
                    <h5>{console.log(item,"itemitem")}
                      {decodeHtml(item.title)} {getSortNamePostType(item.type)}  {getUmbrella(item.is_ambrella)}
                    </h5>
                    <div className="dollar-sec">
                      <p>
                        <GetPrice
                          type={item?.type}
                          price={item?.price}
                          price2={item?.price2}
                          hiring_type={item?.hiring_type}
                        />
                      </p>
                      {item?.type == 3 ? (
                        <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/job-type.svg`}
                            alt=""
                          />
                          Job type: {' '}
                          {item?.work_location == 1
                            ? "Virtual"
                            : item?.work_location == 2
                              ? "Physical"
                              : ""}
                        </p>
                      ) : (
                        <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
                            alt=""
                          />
                          Deadline:{" "}
                          {item?.type == 2 ? (
                            <> {getMemberSince(item?.last_date)} </>
                          ) : (
                            <>
                              <CustomeDurationLabel
                                duration={item?.duration}
                                duration_type={item?.duration_type}
                              />
                            </>
                          )}
                        </p>
                      )}
                      <p>
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/project/message.svg`}
                          alt=""
                        />
                        Posted: {getTimeDifference(item.created_on)}
                      </p>
                    </div>

                    <CustomReactQuillDescription value={item.description}
                      displyreadorless={false} />
                    <div className="photoshop">
                      {Array.isArray(item?.skills) &&
                        item?.skills.map((item1, index1) => (
                          <p key={index1}>{decodeHtml(item1.title)}</p>
                        ))}
                    </div>
                    <div className="proposal">
                      <p>
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/project/proposal.svg`}
                          alt=""
                        />
                        {item?.type == 2 ? "Entries" : "Proposal"}:{' '}
                        {item.proposal_count}
                      </p>
                      {item?.type == 3 && item?.work_location == 2 ? (
                        <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`}
                            alt=""
                          />
                          Location: {decodeHtml(item.city_name)}
                        </p>
                      ) : (
                        ""
                      )}
                      <p>
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/project/payment.svg`}
                          alt=""
                        />
                        Verified Payment
                      </p>
                    </div>
                  </div>

                  <div className="text-center">
                    <AllStatusLabels status_id={item?.proposed_status} />
                    <YourPost item={item} />
                    <button
                      className="btn heart-btn"
                      onClick={() => {
                        if (IS_LOGGED_IN_USER) {
                          item.wishlist == 1
                            ? addtowishlist11(item?.id, 1)
                            : addtowishlist11(item?.id, 1);
                        }
                        else {
                          setModal(true)
                        }
                      }

                      }
                    >
                      {item.wishlist == 1 ? (
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/project/heart-active.svg`}
                          alt=""
                        />
                      ) : (
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/project/heart.svg`}
                          alt=""
                        />
                      )}
                    </button>
                  </div>
                </div>
              )
          )}

          <CommonPagination
            totalitemcounts={
              activeTab == "allpost"
                ? getpostlist?.count?.count
                : activeTab == "recentview"
                  ? getpostlist?.count?.viewed_count
                  : activeTab == "savepost"
                    ? getpostlist?.count?.saved_count
                    : activeTab == "appliedpost"
                      ? getpostlist?.count?.proposed_count
                      : getpostlist?.count?.count
            }
            size={10}
            pageNumber={state?.pageNumber}
            setPageNumber={setPageNumber}
          />
        </>
      ) : (
        <PostNotFound title={"Post Not Found..."} />
      )}
    </div>
  );
}
